import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {deleteRequest, getRequest} from "../../api";

export const handleLoadDefaultPrograms = createAsyncThunk('defaultPlans/handleLoadDefaultPrograms', async() => {
    try{
        const {data} = await getRequest(`/coach/program/default`)
        return data
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleDeleteProgram = createAsyncThunk('defaultPlans/handleDeleteProgram', async(allData) => {
    const {id, index} = allData
    try{
        const {data} = await deleteRequest(`/coach/program/default/${id}`)
        return {data, index}
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

const defaultPlansSlice = createSlice({
    name: 'defaultPlans',
    initialState: {
        defaultPrograms: [],
        selectedProgram: null,
        newDefaultPlan: null,
        status: {
            loadingDefaultProgram: false,
            spinner: false,
            deleteModal: false,
            snackBarMessage: {message: null, type: null},
        }
    },
    reducers: {
        setSelectedProgram: (state, action) => {
            state.selectedProgram = action?.payload
        },
        setDeleteModal: (state, action) => {
            state.status.deleteModal = action?.payload
        },
        setSnackBarMessage: (state, action) => {
            state.status.snackBarMessage = {
                ...state.status.snackBarMessage,
                type: action?.payload?.type
            }
        },
        setNewDefaultPlan: (state, action) => {
            state.newDefaultPlan = action?.payload
        }
    },
    extraReducers(builder){
        builder
            .addCase(handleLoadDefaultPrograms.fulfilled, (state, action) => {
                    if(action?.payload.length > 0){
                        state.defaultPrograms = action?.payload
                        state.status.loadingDefaultProgram = false
                    }
            })
            .addCase(handleLoadDefaultPrograms.pending, (state, action) => {
                state.status.loadingDefaultProgram = true
            })
            .addCase(handleLoadDefaultPrograms.rejected, (state, action) => {
                state.status.loadingDefaultProgram = false
            })
        builder
            .addCase(handleDeleteProgram.fulfilled, (state, action) => {
                const data = action?.payload?.data
                const index = action?.payload?.index
                state.status = {
                    ...state.status,
                    snackBarMessage: {
                        message: data?.message,
                        type: 'submit'
                    },
                    spinner: false,
                    deleteModal: false,
                }
                let filteredDefaultPrograms = state.defaultPrograms.splice(index, 1)
                state.defaultPrograms = filteredDefaultPrograms
            })
            .addCase(handleDeleteProgram.pending, (state, action) => {
                state.status.spinner = true
            })
            .addCase(handleDeleteProgram.rejected, (state, action) => {
                state.status = {
                    ...state.status,
                    snackBarMessage: {
                        message: "با خطا مواجه شد",
                        type: 'error'
                    },
                    spinner: false,
                    deleteModal: false,
                }
            })
    }
})

export const {setSelectedProgram, setDeleteModal, setSnackBarMessage, setNewDefaultPlan} = defaultPlansSlice.actions
export const selectDefaultPrograms = state => state.defaultPlans.defaultPrograms
export const selectSelectedProgram = state => state.defaultPlans.selectedProgram
export const selectLoadingDefaultProgram = state => state.defaultPlans.status.loadingDefaultProgram
export const selectSpinner = state => state.defaultPlans.status.spinner
export const selectDeleteModal = state => state.defaultPlans.status.deleteModal
export const selectDefaultSnackBarMessage = state => state.defaultPlans.status.snackBarMessage
export const selectNewDefaultPlan = state => state.defaultPlans.newDefaultPlan

export default defaultPlansSlice.reducer